import { buildUseCurrentBreakpointHook } from "@thelabnyc/thelabui/src/hooks/layout";

// The header swaps the desktop nav for the mobile hamburger via CSS at 768px
// (`.main-menu-list` is hidden at `$all-small`). The shared
// `useCurrentBreakpoint().belowMobile` resolves to `max-width: 767px`
// (`$mobile` 768 - 1), so at exactly 768px the JS would still report "desktop"
// while the CSS has already switched to mobile -- leaving the nav blank at that
// one-pixel boundary. Pin the header's own `belowMobile` to `max-width: 768px`
// so the JS breakpoint flips in lockstep with the CSS.
// NOTE: keep 768 in sync with `$medium-line` (→ `$medium` → `$all-small`) in
// styles/variables/_layouts.scss, which drives when `.main-menu-list` hides.
export const useHeaderBreakpoint = buildUseCurrentBreakpointHook({
    belowMobile: "(max-width: 768px)",
});
